var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":_vm.size,"width":_vm.size,"fill":"none","stroke":_vm.color,"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},_vm._l((_vm.paths),function(path,index){return _c('path',{key:index,attrs:{"d":path}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }